import React from "react";
import Helmet from "react-helmet";

import { Link } from "gatsby-plugin-intl";
const helpers = require("../../helpers");

import "../../scss/molecules/_breadcrumb.scss";

class Breadcrumb extends React.Component {
  removetrailingSlash(url) {
    if (url.substring(url.length - 1) == "/") {
      return url.substring(0, url.length - 1);
    } else {
      return url;
    }
  }

  render() {
    const { location } = this.props;
    const baseUrl = this.removetrailingSlash(location.pathname);
    const parts = baseUrl.split("/");
    let test = "";
    parts.shift();

    if (parts[0] === "nl" || parts[0] === "en") {
      parts.shift();
    }

    const breadcrumbArr = parts.map((part, index) => {
      const capitalPart = part[0].toUpperCase() + part.substring(1);
      const prePath = baseUrl.split("/", index + 1);

      const prePathString = prePath.join("/");
      const prePathStringScript = prePathString + "/" + part;

      test += JSON.stringify({
        "@type": "ListItem",
        position: index + 1,

        item: {
          "@id": decodeURIComponent(location.origin + prePathStringScript),
          name: decodeURIComponent(capitalPart)
            .split("-")
            .join(" "),
        },
      });

      index < parts.length - 1 ? (test += ",") : (test += "");

      if (parts.length === index + 1) {
        return (
          <li key={index + 1}>
            {decodeURIComponent(capitalPart)
              .split("-")
              .join(" ")}
          </li>
        );
      } else {
        return (
          <li key={index + 1}>
            <Link
              to={helpers.getTrailedUrl(`${prePathString}` + "/" + `${part}`)}
            >
              {decodeURIComponent(capitalPart)
                .split("-")
                .join(" ")}
            </Link>
          </li>
        );
      }
    });

    breadcrumbArr.unshift(
      <li key={0}>
        <Link key="0" to="/">
          Home
        </Link>
      </li>
    );

    return (
      <>
        <Helmet>
          <script type="application/ld+json">{`{
                        "@context": "http://schema.org",
                        "@type": "BreadcrumbList",
                        "itemListElement": [${test}]
                        }`}</script>
        </Helmet>
        <ul className="breadcrumb">{breadcrumbArr}</ul>
      </>
    );
  }
}

export default Breadcrumb;
